module.exports = __webpack_public_path__ + "media/images/home-1-81fb386009e07ae0fafa1992271cef56.svg";